export function archiveOpen() {
    const item = $('.archive .item'),
          year = $('.archive .item .year');

    year.on('click', function () {
        year.not(this).parent('.item').removeClass('active');
        year.not(this).next('.months').slideUp();
            
        $(this).parent('.item').toggleClass('active');

        if($(this).parent('.item').hasClass('active')){
            $(this).next('.months').stop().slideDown();
        }else{
            $(this).next('.months').stop().slideUp();
        }
    });
}